import React from "react";
import { AccentInfo } from "../../../StyledComponents";
import {
  TimelineChangeList,
  TimelineChangeRow,
  TimelineContent,
  TimelineMetaList,
  TimelineMetaRow,
  TimelineNewBadge,
  TimelineSection,
  TimelineSectionTitle,
  TimelineTitle,
  TimelineTitleRow,
} from "../TimelineLayout";

const labelOverrides = {
  "Primary Mortgage Interest Rate": "Mortgage Interest Rate",
  "Primary Mortgage Start Date": "Mortgage Start Date",
  "Primary Mortgage Due Date": "Mortgage Due Datee",
  "Primary Lender Name": "Mortgage Type",
  "Primary Loan Type": "Mortgage Amount",
  "Primary Mortgage Term": "Mortgage Term",
  "Primary Mortgage Amount": "Mortgage Amount",
  "Secondary Mortgage Interest Rate": "2nd Mortgage Start Date",
  "Secondary Mortgage Start Date": "2nd Mortgage Start Date",
  "Secondary Mortgage Due Date": "2nd Mortgage Due Datee",
  "Secondary Lender Name": "2nd Mortgage Type",
  "Secondary Loan Type": "2nd Mortgage Amount",
  "Secondary Mortgage Term": "2nd Mortgage Term",
  "Secondary Mortgage Amount": "2nd Mortgage Amount",
  "Last Sale Recording Document ID": "Sale Recording Doc ID",
  "Last Sale Document Type": "Last Sale Doc Type",
  "Last Sale Seller 1 Full Name": "Seller 1 Full Name",
  "Last Sale Seller 1 First Name": "Seller 1 First Name",
  "Last Sale Seller 1 Last Name": "Seller 1 Last Name",
  "Last Sale Seller 2 Full Name": "Seller 2 Full Name",
  "Last Sale Seller 2 First Name": "Seller 2 First Name",
  "Last Sale Seller 2 Last Name": "Seller 2 Last Name",
  "Last Sale Recording Date": "Sale Recording Date",
  "Assessed Improvement Value": "Assmt Impr Value",
  "Last Sale Doc Type": "Sale Doc Type",
  "Street Address One Line": "Street Address",
}

const formatResolvedValue = (detail, value, fallbackEmpty = "-none-") => {
  if (value === 'Y') return 'YES'
  if (value === 'N') return 'NO'
  if (detail.old && !detail.new && value === detail.old) return <AccentInfo>{fallbackEmpty}</AccentInfo>
  if (detail.field.includes('Rate') || detail.field.includes('%')) return `${value}%`
  if (detail.field.includes('Price') || detail.field.includes('Amount') || detail.field.includes('Value')) {
    return typeof value === 'number'
      ? `$${value.toLocaleString("en-US", {maximumFractionDigits: 0, minimumFractionDigits: 0})}`
      : <AccentInfo style={{fontWeight: '400'}}>{fallbackEmpty}</AccentInfo>
  }
  return value
}

const DiscrepanciesAllResolved = ({milestone}) => (
  <TimelineContent>
    <TimelineTitleRow>
      <TimelineTitle>{milestone.milestone}</TimelineTitle>
      {milestone.notify && <TimelineNewBadge>new</TimelineNewBadge>}
    </TimelineTitleRow>
    <TimelineMetaList>
      <TimelineMetaRow>
        <span className="timeline-meta-label">performed by:</span>
        <span className="timeline-meta-value">{milestone.contributor}</span>
      </TimelineMetaRow>
      <TimelineMetaRow>
        <span className="timeline-meta-label">date:</span>
        <span className="timeline-meta-value">{milestone.date}</span>
      </TimelineMetaRow>
    </TimelineMetaList>
    <TimelineSection>
      <TimelineSectionTitle>Resolved fields</TimelineSectionTitle>
      <TimelineChangeList>
        {milestone.details.map((detail) => (
          <TimelineChangeRow key={detail.label}>
            <span className="timeline-change-label">{labelOverrides[detail.label] || detail.label}:</span>
            <span className="timeline-change-value">
              {formatResolvedValue(detail, detail.old)}
              <span> to </span>
              {formatResolvedValue(detail, detail.new)}
            </span>
          </TimelineChangeRow>
        ))}
      </TimelineChangeList>
    </TimelineSection>
  </TimelineContent>
)

export default DiscrepanciesAllResolved
